/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CheckoutMarkup } from "./CheckoutMarkup";
import {
  CheckoutMarkupFromJSON,
  CheckoutMarkupFromJSONTyped,
  CheckoutMarkupToJSON,
  CheckoutMarkupToJSONTyped,
} from "./CheckoutMarkup";
import type { BigCommerceFreightSettings } from "./BigCommerceFreightSettings";
import {
  BigCommerceFreightSettingsFromJSON,
  BigCommerceFreightSettingsFromJSONTyped,
  BigCommerceFreightSettingsToJSON,
  BigCommerceFreightSettingsToJSONTyped,
} from "./BigCommerceFreightSettings";

/**
 *
 * @export
 * @interface UpdateBigCommerceFreightSettingsRequest
 */
export interface UpdateBigCommerceFreightSettingsRequest {
  /**
   *
   * @type {string}
   * @memberof UpdateBigCommerceFreightSettingsRequest
   */
  integrationId: string;
  /**
   *
   * @type {BigCommerceFreightSettings}
   * @memberof UpdateBigCommerceFreightSettingsRequest
   */
  settings: BigCommerceFreightSettings;
  /**
   *
   * @type {CheckoutMarkup}
   * @memberof UpdateBigCommerceFreightSettingsRequest
   */
  markup: CheckoutMarkup;
}

/**
 * Check if a given object implements the UpdateBigCommerceFreightSettingsRequest interface.
 */
export function instanceOfUpdateBigCommerceFreightSettingsRequest(
  value: object,
): value is UpdateBigCommerceFreightSettingsRequest {
  if (!("integrationId" in value) || value["integrationId"] === undefined)
    return false;
  if (!("settings" in value) || value["settings"] === undefined) return false;
  if (!("markup" in value) || value["markup"] === undefined) return false;
  return true;
}

export function UpdateBigCommerceFreightSettingsRequestFromJSON(
  json: any,
): UpdateBigCommerceFreightSettingsRequest {
  return UpdateBigCommerceFreightSettingsRequestFromJSONTyped(json, false);
}

export function UpdateBigCommerceFreightSettingsRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): UpdateBigCommerceFreightSettingsRequest {
  if (json == null) {
    return json;
  }
  return {
    integrationId: json["integrationId"],
    settings: BigCommerceFreightSettingsFromJSON(json["settings"]),
    markup: CheckoutMarkupFromJSON(json["markup"]),
  };
}

export function UpdateBigCommerceFreightSettingsRequestToJSON(
  json: any,
): UpdateBigCommerceFreightSettingsRequest {
  return UpdateBigCommerceFreightSettingsRequestToJSONTyped(json, false);
}

export function UpdateBigCommerceFreightSettingsRequestToJSONTyped(
  value?: UpdateBigCommerceFreightSettingsRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    integrationId: value["integrationId"],
    settings: BigCommerceFreightSettingsToJSON(value["settings"]),
    markup: CheckoutMarkupToJSON(value["markup"]),
  };
}
